import React from 'react';
import ActionBar from './ActionBar';
import NonProfitCauses from './NonProfitCauses';
import PostAuthorProfile from './PostAuthorProfile';
import ReactionBar from './ReactionBar';
import TwitterContent from './post/TwitterContent';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import { shouldDisablePostCauses } from '@/utils/post.helper';

function TwitterPostBody(props) {
  const { post, type, home, orgSlug = null } = props;
  const { nonProfit } = post.renderProps;

  const disablePostCauses = shouldDisablePostCauses(home, orgSlug);

  return (
    <TrackPostVisibility post={post} type={type}>
      <div className="flex flex-col">
        <div className="flex flex-col gap-4 p-6 lg:p-4">
          {!disablePostCauses && nonProfit && nonProfit.causes && (
            <NonProfitCauses nonProfit={nonProfit} className="border-b pb-4" />
          )}

          <PostAuthorProfile
            post={post}
            home={home}
            orgSlug={orgSlug}
            className="border-b pb-4"
          />
        </div>

        <TwitterContent post={post} />

        <div className="flex flex-col gap-6 px-6 pt-4 lg:px-4">
          <div className={`divide-y ${!nonProfit && 'border-t'}`}>
            <ReactionBar post={post} />

            <div className="flex justify-center py-2">
              <ActionBar post={post} orgSlug={orgSlug} />
            </div>
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default TwitterPostBody;
